// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3hL3v","savePackageButton":"ClientWallet_savePackageButton__31-BA"};